import { Component, OnInit } from '@angular/core';
import { SubscriptionRequest } from "../../models/SubscriptionRequest"
import { SubscriptionEvent } from "../../models/SubscriptionEvent"

import { FormGroup, FormControl } from '@angular/forms';
import { IsoeventsubscriptionmangementserviceService } from '../../services/isoeventsubscriptionmangementservice.service';
import { ActivatedRoute } from '@angular/router';
import { promise } from 'protractor';
import { PrenormalizedTemplateMetadata } from '@angular/compiler';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-unsubscribe',
  templateUrl: './unsubscribe.component.html',
  styleUrls: []
})
export class UnsubscribeComponent implements OnInit {

  pageHeading: string = "Unsubscribe notifications";
  pageSubTitle:string="";
  step1: string = "Step 1";
  step2: string = "Step 2";
  currentStep: string = null;
  listId: string = null;
  userEmail: string = null;
  userMessage: string = null;
  isoEvents: SubscriptionEvent[];

  selecteList:SubscriptionEvent = null;
  submitted: boolean = false;
  requestProcessed: boolean = false;
  messageToDisplay: string = "";
  requestFailed: boolean = false;
  dataLoaded: boolean = false;

  constructor(
    private eventService: IsoeventsubscriptionmangementserviceService, 
    private route: ActivatedRoute,
    private titleService:Title
    ) {

     }


  async ngOnInit(): Promise<void> {

    this.currentStep = this.step1;
    this.listId = this.route.snapshot.paramMap.get('listid') as string;

    if (this.listId) {
      //// load the subscription details based on source id
      await this.eventService.getEventDetails().then(data => {
        this.isoEvents = data

        let matchingLists = this.isoEvents.filter((obj)=>{
          return obj.eventId == this.listId;
        })
        if(matchingLists && matchingLists.length>0)
        {
          this.selecteList = matchingLists[0];
          this.pageHeading  = "Unsubscribe from "+ this.selecteList.eventName;
          this.pageSubTitle ="To unsubscribe from "+this.selecteList.eventName+" please enter your email address below."
          this.titleService.setTitle(this.pageHeading);
        }
        else{
          this.requestFailed= true;
          this.messageToDisplay="Unsubscribe request is not valid.";
        }
      });
      this.dataLoaded = true;
    }
    else {
      this.dataLoaded = true;
      this.requestFailed= true;
      this.messageToDisplay="Unsubscribe request is not valid.";
    }

  }


  // async submit(subscriptionForm):Promise<void>{ 
  //   console.log('Form submitted',subscriptionForm);
  //   await this.eventService.UnsubscribeToEvents(this.model);
  //   this.requestProcessed = true;
  //   this.messageToDisplay = "Request has been processed successfully";

  // }



  async GetUnsubscribeLinkMail(subscriptionFormEmail): Promise<void> {
    if (subscriptionFormEmail.form.status == 'INVALID') {
      this.showValidationMsg(subscriptionFormEmail);
      return;
    }
    else {
      this.dataLoaded = false;
      this.currentStep = "";
      await this.eventService.sendUnsubscribeConfirmEmailAsync(this.userEmail, this.listId).then(data => {
        this.userMessage = data.message
        this.requestProcessed = true; 
      })
      .catch(err => {
        this.requestFailed= true;
        this.messageToDisplay="Something went wrong. Failed to process the request try again or contact the support team.";
       
      });
      
      this.dataLoaded = true;
    }
  }




  ////Method to show validation on button submit click
  showValidationMsg(formGroup: FormGroup) {
    for (const key in formGroup.controls) {

      if (formGroup.controls.hasOwnProperty(key)) {
        const control: FormControl = <FormControl>formGroup.controls[key];

        if (Object.keys(control).includes('controls')) {
          const formGroupChild: FormGroup = <FormGroup>formGroup.controls[key];
          this.showValidationMsg(formGroupChild);
        }

        control.markAsTouched();
      }
    }
  }

}
